import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserStatistics')
export class UserStatistics {

  @JsonProperty('game', Number)
  game: number = 0;

  @JsonProperty('win', Number)
  win: number = 0;

  @JsonProperty('slot_reward', Number)
  slotReward: number = 0;

  @JsonProperty('slot_cost', Number)
  slotCost: number = 0;

  @JsonProperty('game_reward', Number)
  gameReward: number = 0;

  @JsonProperty('game_cost', Number)
  gameCost: number = 0;
}
